import { operatorApiFetch } from './apiService';

export const holidayService = {
  fetchList: async () => {
    const response = await operatorApiFetch('holidays');
    return response.json();
  },

  create: async (data) => {
    const response = await operatorApiFetch('holidays', {
      method: 'POST',
      body: JSON.stringify({ holiday: data }),
    });
    return response.json();
  },

  update: async (id, data) => {
    const response = await operatorApiFetch(`holidays/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ holiday: data }),
    });
    return response.json();
  },

  delete: async (id) => {
    const response = await operatorApiFetch(`holidays/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};
